import { FeatureFlagCollection } from '../interfaces/feature-flag.interface';

export const E2eFeatureFlagMock: Partial<Record<FeatureFlagCollection, boolean>> = Object.freeze({
  [FeatureFlagCollection.userFlows]: true,
  [FeatureFlagCollection.userFlowsGuided]: false,
  [FeatureFlagCollection.tenantRiskScore]: true,
  [FeatureFlagCollection.wsRiskScore]: true,
  [FeatureFlagCollection.dpRiskScore]: true,
  [FeatureFlagCollection.govDashWebsiteAppsNewSection]: true,
  [FeatureFlagCollection.riskChartFrequency]: true,
  [FeatureFlagCollection.scimFunctionality]: true,
  [FeatureFlagCollection.scansListRedesign]: true,
  [FeatureFlagCollection.scansRevampInPopup]: true,
  [FeatureFlagCollection.requestManualEvaluation]: true,
  [FeatureFlagCollection.filteringUsers]: true,
  [FeatureFlagCollection.removedStepper]: true,
  [FeatureFlagCollection.pushManualRequestAudit]: true,
  [FeatureFlagCollection.scanBanner]: true,
  [FeatureFlagCollection.manualEvaluationConformanceTab]: true,
  [FeatureFlagCollection.updateTaskSlideout]: true,
  [FeatureFlagCollection.navSupportPortalUx]: true,
  [FeatureFlagCollection.bulkWsAndDpsCreationWithCustomMonitoringSettings]: true,
  [FeatureFlagCollection.userway_integration]: true,
  [FeatureFlagCollection.organizationPortfolio]: true,
  [FeatureFlagCollection.userFlowsQ42023Revamp]: true,
  [FeatureFlagCollection.mobileAppScans]: true,
  [FeatureFlagCollection.monitoringHistoricalReport]: true,
  [FeatureFlagCollection.evaluationsSummarization]: true,
  [FeatureFlagCollection.automatedFlowPasswordCSSField]: true,
  [FeatureFlagCollection.requestValidationTesting]: true,
  [FeatureFlagCollection.mobileTestingEmulator]: true,
  [FeatureFlagCollection.commonFindings]: false,
  [FeatureFlagCollection.viewIssueTrackingConnectionStatus]: false,
  [FeatureFlagCollection.digitalAssetFindings]: false,
  [FeatureFlagCollection.artificialIntelligenceOptin]: false,
  [FeatureFlagCollection.asanaProjectsPagination]: false,
  [FeatureFlagCollection.newAutomatedEngine]: false,
  [FeatureFlagCollection.scanningAgent]: true,
  [FeatureFlagCollection.artInScansAndMonitoring]: true,
  [FeatureFlagCollection.scanDebugging]: false,
});
